module.exports = __webpack_public_path__ + "img/4.56c81a73.svg";